import React from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core"
import LoadingButton from "../../../LoadingButton"

import useStyles from "./styles"
import { toggleClickConfirmationDialog } from "../../../../actions/billingDialogs"
import { recallShoot } from "../../../../actions/shoots"

const ClickConfirmationDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const open = useSelector(
    state => state.billingDialogs.clickConfirmationDialogOpen
  )
  const data = useSelector(state => state.billingDialogs.data)
  const action = data && data.action
  const confirmationFunc = data && data.confirmationFunc
  const funcArgs = (data && data.funcArgs) || []
  const cancelData = (data && data.cancelData) || {}

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const handleClose = () => {
    let data = { action: action, ...cancelData }
    dispatch(toggleClickConfirmationDialog(false, data))
  }

  const executeConfirmationFunc = () => {
    if (confirmationFunc) {
      confirmationFunc(...funcArgs)
    }

    handleClose()
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">Confirm</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          style={viewportWidth > 600 ? {} : { textAlign: "center" }}
          variant="h5"
        >
          Are you sure you want to {action}?
        </Typography>
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <LoadingButton
          size={viewportWidth > 600 ? "medium" : "small"}
          variant="outlined"
          color="primary"
          className={classes.button}
          onClick={handleClose}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          size={viewportWidth > 600 ? "medium" : "small"}
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => executeConfirmationFunc()}
        >
          Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ClickConfirmationDialog
